import { borderTopWidth } from "html2canvas/dist/types/css/property-descriptors/border-width";

//please adjust these to the colors you want to use
const primaryColor_100 = "#ebfeff"; //primary_100
const primaryColor_800 = "#053B61"; //primary_800


export const customTheme = {
  token: {
    colorBgContainer: primaryColor_100,
    colorPrimary: primaryColor_800,
    colorText: primaryColor_800,
    colorTextLightSolid: primaryColor_800,
    borderRadius: 12,
    lineWidth: 0,
  },
  components: {
    Input: {
      activeBorderColor: primaryColor_800,
      hoverBorderColor: primaryColor_800,
      focusBorderColor: primaryColor_800,
      lineWidth:1
    },
    Select: {
      activeBorderColor: primaryColor_800,
      activeOutlineColor: primaryColor_800,
      hoverBorderColor: primaryColor_800,
      focusBorderColor: primaryColor_800,
    },
    Form: {
      itemMarginBottom: 12,
      labelHeight: 'auto'
    }
  },
}

